import { MarketingPlataformaService } from "../../../shared/generated/grpc/plataforma_marketing_pb";
import { CampanaResponse } from "../../../shared/response/marketing/CampanaResponse";
import { CampanaPayload } from "../../../shared/services/api/payload/marketing/CampanaPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { dateToMs, grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { CampanaService, toCampanaResponse } from "./CampanaService";

/** Alta y edición de campaña; el resultado reemplaza la fila del listado (`upsert` de la base). */
export class CampanaSaveService extends ServiceSaveBase<CampanaResponse, CampanaPayload> {
  protected readonly cache = CampanaService.instance;

  /** gRPC-Web (`Guardar`): sin `id` crea (nace en borrador), con `id` edita. Código único. */
  protected async sendSave(payload: CampanaPayload): Promise<CampanaResponse> {
    const c = await grpcCall(() => grpcClient(MarketingPlataformaService).guardar({
      id: payload.id ?? undefined,
      nombre: payload.nombre,
      tipo: payload.tipo,
      objetivo: payload.objetivo,
      codigo: payload.codigo ?? undefined,
      cuposMaximos: payload.cuposMaximos,
      fechaLimite: dateToMs(payload.fechaLimite),
      urlLanding: payload.urlLanding ?? undefined,
      activaDemo: payload.activaDemo,
      mensajeTemplate: payload.mensajeTemplate ?? undefined,
    }));
    return toCampanaResponse(c);
  }
}
